import { createSlice } from "@reduxjs/toolkit"
import type { PayloadAction } from "@reduxjs/toolkit"

interface AuthUser {
  userUid: string
  firstName: string
  lastName: string
  email: string
  role: string
}

interface AuthState {
  user: AuthUser | null
  token: string | null
}

const initialState: AuthState = {
  user: (() => { try { return JSON.parse(localStorage.getItem("adminUser") ?? "null") } catch { return null } })(),
  token: localStorage.getItem("adminToken"),
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials(state, action: PayloadAction<{ user: AuthUser; token: string }>) {
      state.user = action.payload.user
      state.token = action.payload.token
      localStorage.setItem("adminToken", action.payload.token)
      localStorage.setItem("adminUser", JSON.stringify(action.payload.user))
    },
    clearCredentials(state) {
      state.user = null
      state.token = null
      localStorage.removeItem("adminToken")
      localStorage.removeItem("adminUser")
    },
  },
})

export const { setCredentials, clearCredentials } = authSlice.actions
export default authSlice.reducer
